const mapStateToProps = state => 
     ({
        data: state.certificacionDeGoceDeSusDerechosPoliticos.data,
    });

export default mapStateToProps;
